import { RootState } from "../../infrastructure/state/store";

export const activityHistorySearchStringSelector = (state: RootState) =>
  state.activityHistoryFilters.searchString;
